import React from 'react';

interface INotificationBell {
  className?: string;
  size?: string;
}

const NotificationBell: React.FC<INotificationBell> = props => {
  const { className = '', size = '20' } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_953_50685"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={size}
        height={size}
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_953_50685)">
        <path
          d="M3.3335 15.8334V14.1667H5.00016V8.33335C5.00016 7.18058 5.34738 6.15613 6.04183 5.26002C6.73627 4.36446 7.63905 3.7778 8.75016 3.50002V2.91669C8.75016 2.56946 8.87183 2.27446 9.11516 2.03169C9.35794 1.78835 9.65294 1.66669 10.0002 1.66669C10.3474 1.66669 10.6424 1.78835 10.8852 2.03169C11.1285 2.27446 11.2502 2.56946 11.2502 2.91669V3.50002C12.3613 3.7778 13.2641 4.36446 13.9585 5.26002C14.6529 6.15613 15.0002 7.18058 15.0002 8.33335V14.1667H16.6668V15.8334H3.3335ZM10.0002 18.3334C9.54183 18.3334 9.14961 18.1703 8.8235 17.8442C8.49683 17.5175 8.3335 17.125 8.3335 16.6667H11.6668C11.6668 17.125 11.5038 17.5175 11.1777 17.8442C10.851 18.1703 10.4585 18.3334 10.0002 18.3334Z"
          fill="#0276FE"
        />
      </g>
    </svg>
  );
};

export default NotificationBell;
